import { Typography } from "@mui/material";

import ContactsUnavailable from "../../../ui library/icons/ContactsUnavailable";

export default function NoDataContainer() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-2 rounded-lg bg-sky-100 p-8">
      <ContactsUnavailable />
      <Typography className="text-center font-['Robot_Slab'] text-xl text-blue-700">
        <span className="font-semibold">No Contacts Available</span>
      </Typography>
    </div>
  );
}
